import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./Components/Header";
import Home from "./Components/Home/Home";
import Footer from "./Components/Footer";
import AboutUs from "./Components/AboutUs";
import ContactUs from "./Components/ContactUs";
import SupportWidget from "./Components/SupportWidget";
import AllServices from "./Components/AllServices";
//import Gallery from './Components/Gallery';

const App = () => {
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/service" element={<AllServices />} />
         {/*<Route path="/gallery" element={<Gallery />} />*/}
      </Routes>
      <SupportWidget />
      <Footer />
    </>
  );
};

export default App;
